<template></template>

<script>
export default {
  created() {
    if (this.$route.query.code) {
      location.href = `${process.env.VUE_APP_API_URL}sso/qycallback?code=${this.$route.query.code}&state=null`;
    }
  },
};
</script>

<style>
</style>